import { render, staticRenderFns } from "./TwoAuth.vue?vue&type=template&id=36cf4ba6&scoped=true"
import script from "./TwoAuth.vue?vue&type=script&lang=js"
export * from "./TwoAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoAuth.vue?vue&type=style&index=0&id=36cf4ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4ba6",
  null
  
)

export default component.exports